import { render } from "./TestForm.vue?vue&type=template&id=e31e6d3a&scoped=true"
import script from "./TestForm.vue?vue&type=script&lang=js"
export * from "./TestForm.vue?vue&type=script&lang=js"

import "./TestForm.vue?vue&type=style&index=0&id=e31e6d3a&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e31e6d3a"]])

export default __exports__